<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" color="secondary" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div id="account-required-content" class="ion-padding">
    <header class="account-required__header">
      <img
        class="account-required__icon"
        loading="lazy"
        decoding="async"
        src="assets/images/image-account.webp"
        alt=""
      />

      <h1 class="account-required__title">
        {{ 'shared.accountRequired.label.title' | transloco }}
      </h1>

      <p class="account-required__description">
        <span class="account-required__description-text">
          {{ 'shared.accountRequired.label.description' | transloco }}
        </span>
        <span class="account-required__description-highlight">
          {{ 'shared.accountRequired.label.descriptionHighlight' | transloco }}
        </span>
      </p>
    </header>

    <ul class="account-required__perks">
      <li class="account-required__perk">
        <ion-icon
          name="mail-outline"
          class="account-required__perk-icon"
        ></ion-icon>
        <span class="account-required__perk-text">
          {{ 'shared.accountRequired.label.benefits.confirmation' | transloco }}
        </span>
      </li>
      <li class="account-required__perk">
        <ion-icon
          name="calendar-outline"
          class="account-required__perk-icon"
        ></ion-icon>
        <span class="account-required__perk-text">
          {{ 'shared.accountRequired.label.benefits.manage' | transloco }}
        </span>
      </li>
      <li class="account-required__perk">
        <ion-icon
          name="checkmark-circle-outline"
          class="account-required__perk-icon"
        ></ion-icon>
        <span class="account-required__perk-text">
          {{ 'shared.accountRequired.label.benefits.quickAccess' | transloco }}
        </span>
      </li>
    </ul>
  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-button
      color="primary"
      expand="block"
      shape="round"
      (click)="onNavigateToRegisterPage()"
    >
      {{ 'shared.accountRequired.button.createAccount' | transloco }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
